export default (state = null, action) => {
    let { type, payload } = action
    switch (type) {
        case 'ON_SELECTED_MARKER_ID':
            return payload
        case 'ON_SELECTED_MARKER_ID_NULL':
            return null
        default:
            return state
    }
}